import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  template: require('./tax-group.actions.component.html')
})
export class TaxGroupActionsComponent {
  @Input() record: any;

  @Output() onCancelClick : EventEmitter<any> = new EventEmitter();
  @Output() onEditClick   : EventEmitter<any> = new EventEmitter();
  @Output() onSaveClick   : EventEmitter<any> = new EventEmitter();
}
